import React from "react";
import Slider from "react-slick";
import { useData } from "../../context/DataContext";
import Button from "../utils/Button";

const JoinUs = () => {
  const { join_us_banners,join_us_link } = useData();
  return (
    <div>
      <div className="">
        <Slider autoplay={true} className="overflow-hidden" autoplaySpeed={3000} pauseOnHover={false}>
          {join_us_banners?.photos?.map((el) => {
        return (
          <div className="">
            {el.type === "image" ? (
              <img className="w-100 cover" src={el.src} alt={el.src} />
            ) : el.type === "video" ? (
              <video
                autoPlay
                loop
                playsInline
                className={"w-100 cover"}
                src={el?.src}
              ></video>
            ) : (
              <div>The File You've uploaded is not Correct</div>
            )}
          </div>
        );
      })}
        </Slider>
        <div className="text-center">
        <div className="my-3">
          <Button
            component="a"
            variant="contained"
            color="primary"
            className="text-decoration-none px-4"
            href={join_us_link.link}
            disabled={!join_us_link.link}
          >
            {join_us_link.link_text}
          </Button>
        </div>
        </div>
      </div>
    </div>
  );
};

export default JoinUs;
